export enum TableViewMode {
  preview = 'preview',
  full = 'full'
}

export type TableViewModeType = TableViewMode.preview | TableViewMode.full

/** 列表 preview 模式（如首页 TOP10）每页条数，与「最近10条」类文案一致 */
export const TABLE_PREVIEW_PAGE_SIZE = 10

/** 与 CmTable 默认 pageOpt.pageSize 一致，full 模式请求兜底 */
export const TABLE_FULL_PAGE_SIZE_DEFAULT = 20

